var map = {
	"./3-men.jpg": 99220,
	"./airplane-window-featured.jpg": 61497,
	"./airplane-window.jpg": 81233,
	"./banner-media-release-2020-08.jpg": 92190,
	"./banner-media-release-28d-travel-insurance.jpg": 17267,
	"./banner-media-release-asia.jpg": 93992,
	"./banner-media-release-aug6.jpg": 13271,
	"./banner-media-release-dec4-applepay.jpg": 5343,
	"./banner-media-release-dec4-genoapay.jpg": 15790,
	"./banner-media-release-latitudepay-moshtix.jpg": 35643,
	"./banner-media-release-nov8.jpg": 96784,
	"./banner-media-release-nz-travel-survey.jpg": 76867,
	"./banner-media-release-oct1.jpg": 39101,
	"./banner-media-release-oct15.jpg": 3160,
	"./banner-media-release-oct16.jpg": 61307,
	"./banner-media-release-oct2.jpg": 98920,
	"./banner-media-release-oct4.jpg": 74431,
	"./banner-media-release-sep11.jpg": 91640,
	"./banner-media-release-sep24.jpg": 36404,
	"./banner-media-release-sep3.jpg": 9810,
	"./banner-media-release-shopping.jpg": 54965,
	"./beach.jpg": 64316,
	"./blue-shopping-bag-banner.jpg": 10193,
	"./blue-shopping-bag.jpg": 18503,
	"./bushfire.jpg": 37580,
	"./capital-notes.jpg": 34429,
	"./cool-guy.jpg": 57187,
	"./data-officer.jpg": 78270,
	"./david-jones-signs-latitude-as-credit-cards-partner-in-exclusive-10-year-deal.jpg": 89062,
	"./desktop.jpg": 19749,
	"./employee.jpg": 44772,
	"./flight-delay.jpg": 39286,
	"./happy-travellers.jpg": 76776,
	"./international-business.jpg": 90245,
	"./lady-jumping.jpg": 44186,
	"./latitude-asx.jpg": 1187,
	"./latitude-hipster.jpg": 28522,
	"./latitude-releases-fy22-results.jpg": 99289,
	"./list-on-asx.jpg": 11598,
	"./media-release-hero.jpg": 1480,
	"./moshtix.jpg": 61496,
	"./newsroom-header-option.jpg": 49592,
	"./newsroom-header-option2.jpg": 84798,
	"./orange-shopping-bags.jpg": 47216,
	"./pink-shopping-bag.jpg": 26367,
	"./pool-guy.jpg": 80200,
	"./profit.jpg": 33166,
	"./prospectus.jpg": 78323,
	"./richmond-and-latitude-logo.jpg": 42045,
	"./richmond-sponsorship.jpg": 84009,
	"./richmond.jpg": 81646,
	"./shinsei.jpg": 19962,
	"./shoppers-at-jb.jpg": 86561,
	"./symple.jpg": 68886,
	"./symple2.jpg": 78771,
	"./travelling-couple.jpg": 13155,
	"./way-forward-single-banner.jpg": 32974,
	"./way-forward-single.jpg": 96017,
	"./wayforward.jpg": 74297,
	"./work.jpg": 64767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35518;